import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

import { TwtOrderType } from '~/tenants/twt/model/enums';

export default createPerformableConfig(
  'slideshow',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      //template: z.union([z.literal('bubbles'), z.literal('basic')]),
    }),
  },
  {
    name: 'Social Media Slideshow',
    // Says what it has over the Vertical Social Video (14 Oct 2026), which is
    // offered beside it: the MLS-ready unbranded 16:9. No unbranded 9:16 is
    // made since 3 Oct 2026 (slideshowVariants), so none is promised.
    short:
      'An MLS-ready unbranded 16:9 video (1920x1080), plus your branded 9:16 (1080x1920) for Instagram, TikTok, Facebook Reels and YouTube Shorts. 1 to 2 minutes, depending on the number of photos.',
    tenant: TenantId.TWIST_TOURS,
    thumbnail(metadata: Record<string, unknown>) {
      if ('type' in metadata && metadata.type === TwtOrderType.COMMERCIAL) {
        return 'tenant/twt/slideshow/commercial.png';
      }

      return 'tenant/twt/slideshow/residential.png';
    },
    images: [],
  },
);
